import { Avatar } from "../../../components/Avatar/Avatar";
import styles from "./WinnerCard.module.scss";
import {IWinnerData, WinReason} from "../../../redux/draws/get-winners.handler";
import { FC } from "react";
import { unixToShortString } from "../../../utils/time";
import {
    getUserProfileHref,
    getUserProfileLinkLabel,
} from "../../../utils/platform-links";
import { getPlatform, Platform } from "../../../platform/platform";

export const WinnerCard: FC<IWinnerData> = ({ username, name, wins, userId }) => {
    const profileHref = getUserProfileHref(userId, username);
    const profileLinkLabel = getUserProfileLinkLabel(name, username);
    const showProfileHrefInText = getPlatform() !== Platform.Telegram;

    const getWinReasonText = (winReason: WinReason) => {
        switch (winReason) {
            case WinReason.Draw: return 'Розыгрыш';
            case WinReason.FragmentsComplete: return 'Фрагменты';
            case WinReason.CollectionComplete: return 'Коллекция';

            case WinReason.None:
            default: return '';
        }        
    }
    
    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <Avatar name={ name } />
                
                <div>
                    <h3 className={styles.name}>{name}</h3>
                    { profileHref &&
                        <a
                            href={profileHref}
                            className={styles.telegram}
                        >
                            { showProfileHrefInText
                                ? `${profileLinkLabel} (${profileHref})`
                                : profileLinkLabel }
                        </a>
                    }
                </div>
            </div>

            <div className={styles.table}>
                <div className={styles.tableHeader}>
                    <span className={styles.dateColumn}>Дата</span>
                    <span className={styles.reasonColumn}>Тип</span>
                    <span className={styles.amountColumn}>Выигрыш</span>
                </div>

                <div className={styles.rowBlock}>
                    {wins.map((win, index) => (
                        <div key={index} className={styles.tableRow}>
                            <span className={`${styles.date} ${styles.dateColumn}`}>
                                {unixToShortString(win.date)}
                            </span>
                            <span className={`${styles.reason} ${styles.reasonColumn}`}>
                                {getWinReasonText(win.reason)}
                            </span>
                            <span className={`${styles.amount} ${styles.amountColumn}`}>
                                {`${win.value} руб.`}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
